<div class="dropdown">
    <button type="button" id="property-charge-schedule-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
        data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
        Filter
        @if (filterCount > 0) {
        <span
            class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{filterCount}}</span>
        }
    </button>

    <!--begin::Menu 1-->
    <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()">

        <!--begin::Header-->
        <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>
        <!--end::Header-->

        <!--begin::Separator-->
        <div class="separator border-gray-200"></div>
        <!--end::Separator-->

        <!--begin::Content-->

        <!-- Name Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Name:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter name"
                    [(ngModel)]="nameInput" (keyup.enter)="addName()" />
                <button class="btn btn-primary px-3" type="button" (click)="addName()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added names -->
                @if (activeFilter.names && activeFilter.names.length > 0) {
                <div class="mt-2">
                    @for (name of activeFilter.names; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeName($index)">{{name}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Property Title Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Property Title:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter property title"
                    [(ngModel)]="propertyTitleInput" (keyup.enter)="addPropertyTitle()" />
                <button class="btn btn-primary px-3" type="button" (click)="addPropertyTitle()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">                
                <!-- Display added property titles -->
                @if (activeFilter.titles && activeFilter.titles.length > 0) {
                <div class="mt-2">
                    @for (propertyTitle of activeFilter.titles; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removePropertyTitle($index)">{{propertyTitle}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Property Address Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Property Address:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter property address"
                    [(ngModel)]="propertyAddressInput" (keyup.enter)="addPropertyAddress()" />
                <button class="btn btn-primary px-3" type="button" (click)="addPropertyAddress()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added property addresses -->
                @if (activeFilter.primaryAddresses && activeFilter.primaryAddresses.length > 0) {
                <div class="mt-2">
                    @for (address of activeFilter.primaryAddresses; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removePropertyAddress($index)">{{address}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Lot Number Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Lot Number:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter lot number"
                    [(ngModel)]="lotNumberInput" (keyup.enter)="addLotNumber()" />
                <button class="btn btn-primary px-3" type="button" (click)="addLotNumber()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added lot numbers -->
                @if (activeFilter.lotNumbers && activeFilter.lotNumbers.length > 0) {
                <div class="mt-2">
                    @for (lotNumber of activeFilter.lotNumbers; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeLotNumber($index)">{{lotNumber}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Modified Date Range Input -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Modified Date:</label>
            <div class="row">
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="minModifiedDateInput" (change)="onMinModifiedDateChange()" />
                </div>
                <div class="col-6">
                    <input type="date" class="form-control form-control-solid"
                        [(ngModel)]="maxModifiedDateInput" (change)="onMaxModifiedDateChange()" />
                </div>
            </div>
        </div>

        <!-- Scheduled Amount Input -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Scheduled Amount:</label>
            <div class="row">
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Min"
                        [(ngModel)]="minScheduledAmountDisplay" />
                </div>
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Max"
                        [(ngModel)]="maxScheduledAmountDisplay" />
                </div>
            </div>
        </div>

        <!--begin::Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Status:</label>
            <ms-multi-select placeholder="Select Status" [options]="selectPropertyStatusOptions"
                [(selectedOptions)]="selectedPropertyStatus" (selectionChange)="onStatusChange($event)" />
        </div>
        <!--end::Multi-select Input group-->

        <!--begin::Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Frequency:</label>
            <ms-multi-select placeholder="Select Frequency" [options]="selectScheduleFrequencyOptions"
                [(selectedOptions)]="selectedFrequencies" (selectionChange)="onFrequencyChange($event)" />
        </div>
        <!--end::Multi-select Input group-->

        <!--begin::Actions-->
        <div class="d-flex justify-content-end px-3 py-2">
            <button type="button" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                (click)="onReset()">Reset</button>
            <button type="button" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
        </div>
        <!--end::Actions-->

        <!--end::Content-->
    </div>
    <!--end::Menu 1-->
</div>
